import styled from 'styled-components';
import upgradePlanBgImage from '../../../static/img/upgrade-plan-bg-image.png';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 30, 30, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: linear-gradient(180deg, #F5F2FF 0%, #B9A0F8 100%);

  border-radius: 16px;
  padding: 52px 32px 24px;
  box-sizing: border-box;
  max-height: calc(100vh - 32px); /* browsers without dvh (older iPads, Chromebooks) */
  max-height: calc(100dvh - 32px);
  width: 90%;
  max-width: min(1200px, calc(100vw - 40px));
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  font-family: var(--font-family-ibm_plex_sans);
  text-align: left;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 700px) {
    width: calc(100vw - 24px);
    max-width: none;
    padding: 52px 16px 16px;
  }
`;

export const BackgroundPattern = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${upgradePlanBgImage});
  pointer-events: none;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-family: var(--font-family-ibm_plex_sans);
  z-index: 10;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;

export const UpgradeLabel = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #2E2277;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  position: relative;
  z-index: 5;
`;

export const ModalTitle = styled.h2`
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 32px 0;
  padding-top: 12px;
  text-align: center;
  font-family: var(--font-family-ibm_plex_sans);
  position: relative;
  z-index: 5;
`;

export const PlanGrid = styled.div`
  flex-shrink: 0;
  @media (max-width: 700px) { flex-direction: column; }
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  position: relative;
  z-index: 5;
  overflow-x: hidden;
  overflow-y: visible;
  justify-content: center;
  flex-wrap: nowrap;
  
  @media (max-width: 1440px) {
    gap: 20px;
  }
  
  @media (max-width: 1366px) {
    gap: 16px;
  }
  
  @media (max-width: 1280px) {
    gap: 12px;
  }
`;

export const PlanCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 0px 24px 24px 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 300px;
  min-width: 0;
  flex: 0 1 300px;
  box-sizing: border-box;
  
  @media (max-width: 1440px) {
    flex: 0 1 calc(33.333% - 16px);
    width: auto;
  }
  
  @media (max-width: 1366px) {
    flex: 0 1 calc(33.333% - 12px);
    width: auto;
  }
  
  @media (max-width: 1280px) {
    flex: 0 1 calc(33.333% - 10px);
    width: auto;
  }
  
  @media (max-width: 700px) {
    flex: none;
    width: 100%;
    max-height: none;
    overflow: visible;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
`;

export const PlanHeader = styled.div`
  width: calc(100% + 48px);
  margin: 0 -24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  border-radius: 0 0 20px 20px;
  min-height: 140px;
  position: relative;
  padding-top: 0;
  overflow: hidden;
`;

export const PlanLabel = styled.div`
  background: #2E2277;
  width: 100%;
  color: white;
  padding: 8px 12px;
  border-radius: 12px 12px 0 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const PlanName = styled.h3`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 700;
  font-size: 48px;
  line-height: 130%;
  letter-spacing: -2%;
  text-align: center;
  color: #1a1a1a;
  margin: 0;
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
`;

export const PlanSubtitle = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0%;
  text-align: center;
  margin: 0;
`;

export const PlanPrice = styled.div`
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #1a1a1a;
  margin: 8px 0;
`;

export const PlanToggle = styled.div`
  display: flex;
  background: #f3f4f6;
  border-radius: 30px;
  padding: 4px;
  gap: 4px;
  width: fit-content;
  margin: 0 auto;
`;

export const ToggleButton = styled.button`
  padding: 8px 12px;
  border: none;
  border-radius: 30px;
  background: ${props => props.active ? '#2E2277' : 'transparent'};
  color: ${props => props.active ? 'white' : '#6b7280'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    background: ${props => props.active ? '#2E2277' : 'rgba(255, 255, 255, 0.5)'};
  }
`;

export const PlanDescription = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0%;
  text-align: center;
  margin: 0;
  color: var(--color-neutral-600, #4A4A4A);
`;

export const PlanButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  
  ${props => {
    if (props.disabled) {
      return `
        border: 1px solid var(--color-neutral-200, #918B97);
        color: var(--color-neutral-200, #918B97);
        background: #fff
        cursor: not-allowed;
      `;
    } else if (props.primary) {
      return `
        background: #2E2277;

        color: white;
        
        &:hover {
          background: #5a00b3;
        }
      `;
    } else if (props.secondary) {
      return `
        background: white;
        color: #2E2277;
        border: 2px solid #2E2277;
        
        &:hover {
          background: #f8f6ff;
        }
      `;
    }
  }}
`;

export const PlanFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #000000;

`;

export const FeatureIcon = styled.span`
  color: #10b981;
  font-weight: bold;
  font-size: 18px;
`;

// Tutoring card (JED-1486): the "New" pill sits above the plan name, which PlanName pins at 60px.
export const NewPill = styled.span`
  position: absolute;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 10px;
  border-radius: 999px;
  background: #f0e7ff;
  color: #5a00b3;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
`;

// Same height as the Plus card's billing toggle, so the cards' rows line up.
export const CardChips = styled.div`
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CardChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  font-weight: 500;
`;
